// filterTypes.ts
import {
  SimpleEventFilterType,
  DerivedEventFilterType,
  SubjectVariableFilterType,
} from '@verantos-dev/types-cohorts';

export const FILTER_KEYS = [
  'conceptFilters',
  'numericFilters',
  'relatedEntityFilters',
  'uniquenessFilters',
] as const;
export type FilterKey = (typeof FILTER_KEYS)[number];

export const DERIVED_EVENT_FILTER_KEYS = [
  'eventFilters',
  'uniquenessFilters',
  'temporalConstraints',
] as const;
export type DerivedEventFilterKey = (typeof DERIVED_EVENT_FILTER_KEYS)[number];

export const SUBJECT_VARIABLE_FILTER_KEYS = [
  'numericFilters',
  'conceptFilters',
  'countFilter',
] as const;
export type SubjectVariableFilterKey = (typeof SUBJECT_VARIABLE_FILTER_KEYS)[number];

export const SIMPLE_EVENT_FILTER_MAPPING: Record<FilterKey, SimpleEventFilterType> = {
  conceptFilters: SimpleEventFilterType.CONCEPT,
  numericFilters: SimpleEventFilterType.NUMERIC,
  relatedEntityFilters: SimpleEventFilterType.RELATED_ENTITY,
  uniquenessFilters: SimpleEventFilterType.UNIQUENESS,
};

export const DERIVED_EVENT_FILTER_MAPPING: Record<DerivedEventFilterKey, DerivedEventFilterType> = {
  eventFilters: DerivedEventFilterType.EVENT,
  uniquenessFilters: DerivedEventFilterType.UNIQUENESS,
  temporalConstraints: DerivedEventFilterType.TEMPORAL,
};

export const SUBJECT_VARIABLE_FILTER_MAPPING: Record<
  SubjectVariableFilterKey,
  SubjectVariableFilterType
> = {
  numericFilters: SubjectVariableFilterType.NUMERIC,
  conceptFilters: SubjectVariableFilterType.CONCEPT,
  countFilter: SubjectVariableFilterType.COUNT,
};
